
  import { defineComponent } from "vue"

  export default defineComponent({
    name: 'CreditBoxNavigationTab',

    props: ['isActive', 'href']
  })
